const HALOGEN_BASE_URL = 'https://halogen.fly.dev'; 
// const HALOGEN_BASE_URL = 'http://localhost:3000'; 

const getClips = async (numClips, sortBy, index) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getClips?numClips=${numClips}&sortBy=${sortBy}&index=${index}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clips:', error);
        throw error;
    }
};

const getEmbeddingFilteredClips = async (numClips, index, queryTerm) => {
    try {
        const encodedQueryTerm = encodeURIComponent(queryTerm.trim());
        const response = await fetch(`${HALOGEN_BASE_URL}/getEmbeddingFilteredClips?numClips=${numClips}&index=${index}&queryTerm=${encodedQueryTerm}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clips:', error);
        throw error;
    }
}

const getCategoryFilteredClips = async (numClips, sortBy, index, categoryKeys) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getCategoryFilteredClips?numClips=${numClips}&sortBy=${sortBy}&index=${index}&categoryKeys=${categoryKeys.join(',')}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clips:', error);
        throw error;
    }
};

const getCategoryAndEmbeddingFilteredClips = async (numClips, index, queryTerm, categoryKeys) => {
    try {
        const encodedQueryTerm = encodeURIComponent(queryTerm.trim());
        const response = await fetch(`${HALOGEN_BASE_URL}/getCategoryAndEmbeddingFilteredClips?numClips=${numClips}&index=${index}&queryTerm=${encodedQueryTerm}&categoryKeys=${categoryKeys.join(',')}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clips:', error);
        throw error;
    }
};


const getClip = async (clipId) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getClip?clipId=${clipId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clip:', error);
        throw error;
    }
};

const getScreenshotSignedUrl = async (clipId, size) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getScreenshotSignedUrl?clipId=${clipId}&size=${size}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching screenshot signed URL:', error);
        throw error;
    }
};

const getSimilarClips = async (clipId, numClips) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getSimilarClips?clipId=${clipId}&numClips=${numClips}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching similar clips:', error);
        throw error;
    }
};

const getClipSignedUrl = async (clipId) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getClipSignedUrl?clipId=${clipId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clip signed URL:', error);
        throw error;
    }
};

const recordListen = async (clipId) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/recordListen?clipId=${clipId}`, {
            method: 'POST'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error recording listen:', error);
        throw error;
    }
}

const getClipListens = async (clipId, numDays=99999) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getClipListens?clipId=${clipId}&numDays=${numDays}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching clip listens:', error);
        throw error;
    }
};

const addComment = async (clipId, commentText) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/addComment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ clipId, comment: commentText }),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error adding comment:', error);
        throw error;
    }
};

const addReply = async (clipId, parentId, commentText) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/addReply`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ clipId, parentId, comment: commentText }),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error adding reply:', error);
        throw error;
    }
};

const getComments = async (clipId) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getComments?clipId=${clipId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching comments:', error);
        throw error;
    }
};

const getReplies = async (commentId) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getReplies?parentId=${commentId}`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching replies:', error);
        throw error;
    }
};

const incrementMinutesListened = async () => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/incrementMinutesListened`, {
            method: 'POST'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
    } catch (error) {
        console.error('Error incrementing minutes listened:', error);
        throw error;
    }
}

const postFeedback = async (feedback, email) => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/postFeedback`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ feedback, email }),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
    } catch (error) {
        console.error('Error posting feedback:', error);
        throw error;
    }
}

const getCategories = async () => {
    try {
        const response = await fetch(`${HALOGEN_BASE_URL}/getCategories`);
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
}

export {
    getClips, getEmbeddingFilteredClips, getCategoryFilteredClips, getCategoryAndEmbeddingFilteredClips, getScreenshotSignedUrl,
    getClip, getSimilarClips, getClipSignedUrl, recordListen, getClipListens,
    addComment, addReply, getComments, getReplies, incrementMinutesListened,
    postFeedback, getCategories
};